import React from "react";
import ReactDOM from "react-dom";
import { Clock } from "./clock";
import { StopButton } from "./stop-button";
import { Counter } from "./counter";
import "./styles.css";

const clockA = new Counter();
const clockB = new Counter();

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container">
        <div className="clock">
          <Clock counter={clockA} />
          <StopButton counter={clockA} />
        </div>
        <div className="clock">
          <Clock counter={clockB} />
          <StopButton counter={clockB} />
        </div>
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));
